// extracted by mini-css-extract-plugin
export default {"wrapper":"YXyB9vXE01_zvEWxUkZs"};